import { FAQType } from "./type"
import { FAQ_TYPE } from "../index"

export const FAQ: FAQType[] = [
    {
        type: FAQ_TYPE.STORIES,
        isCollapse: false,
        faq: [
            {
                content: ["GIFT CARDS là một nền tảng voucher đầu tiên tại Việt Nam được xây dựng trên nền tảng công nghệ Blockchain. Đây còn là một cầu nối giữa điểm thưởng VNDC sang voucher đến từ 437 thương hiệu nổi tiếng trên toàn quốc và thế giới."],
                image: "/images/giftcards/giftcard_stories.png",
            },
            {
                content: ["Giftcards.vn lấy ý tưởng từ việc đơn giản hóa việc thanh toán cho các nhu cầu hàng ngày bằng việc đổi thưởng VNDC sang các loại voucher trên các nền tảng mua sắm. Chúng tôi không chỉ cung cấp các thẻ quà tặng mà còn tạo ra một nền tảng linh hoạt cho người dùng sử dụng VNDC của họ để mua sắm và thanh toán các dịch vụ hàng ngày. Từ việc nạp tiền điện thoại di động cho đến thanh toán các hóa đơn, Giftcards.vn thực sự đem lại sự thuận tiện và linh hoạt khi ứng dụng công nghệ Blockchain trong cuộc sống hàng ngày. Ý tưởng này không chỉ giúp người dùng tiết kiệm thời gian mà còn khuyến khích việc áp dụng Blockchain vào mọi khía cạnh của cuộc sống, từ nhu cầu cơ bản đến những giao dịch tiện ích hơn."]
            }
        ]
    },
    {
        type: FAQ_TYPE.USER_MANUAL,
        isCollapse: !false,
        faq: [
            {
                title: "Gift cards là gì?",
                content: ["Gift cards không chỉ đơn thuần là những thẻ quà tặng, mà còn là một nền tảng kết nối những chương trình quà tặng điện tử và chăm sóc khách hàng thân thiết của các doanh nghiệp. Với Giftcards.vn, việc kết nối này trở nên dễ dàng hơn bao giờ hết.", "Kết hợp với Urbox - nền tảng kết nối các chương trình quà tặng và ưu đãi doanh nghiệp tới các nhà cung cấp khuyến mại. Gift cards cho phép người dùng có thể dễ dàng đổi voucher của hơn 437 thương hiệu nổi tiếng toàn quốc như: Shopee Food, CGV, Pharmacity, Circle K,... cho đến các thương hiệu quốc tế: Vascara, Topzone,…", "Bằng cách sử dụng mạng lưới BNB Smart Chain (BSC) và ONUS Chain, Giftcards.vn đảm bảo rằng trải nghiệm của người dùng không chỉ an toàn và riêng tư mà còn nhanh chóng và hiệu quả. Chỉ cần cung cấp địa chỉ email, người dùng có thể nhận biên lai, mã phiếu thưởng nếu có và tận hưởng dịch vụ khách hàng tận tâm từ Giftcards.vn. Điều này thực sự tạo ra một môi trường mua sắm và thanh toán linh hoạt, an toàn và tiện ích cho người dùng tiền điện tử."],
            },
            {
                title: "Làm cách nào để sử dụng thẻ quà tặng Gift cards?",
                content: [
                    "Để sử dụng thẻ quà tặng từ Giftcards.vn, bạn có thể làm theo các bước sau:",
                    "1. Truy cập vào trang web Giftcards.vn.",
                    "2. Chọn sản phẩm hoặc thương hiệu mà bạn muốn đổi voucher.",
                    "3. Đặt số lượng và mệnh giá thẻ quà tặng theo mong muốn của bạn.",
                    "4. Chọn hình thức nhận quà thông qua Email hoặc Zalo.",
                    "5. Kiểm tra lại thông tin của đơn hàng để chắc chắn đúng sản phẩm và thông tin nhận quà.",
                    "6. Chọn phương thức thanh toán và thực hiện thanh toán bằng ví điện tử yêu thích của bạn.",
                    "7. Sau khi thanh toán, xác nhận thanh toán và chờ nhận mã/ PIN của thẻ quà tặng của bạn.",
                    "Thường sau khi xác nhận thanh toán, bạn sẽ nhận được email xác nhận chứa mã/PIN của thẻ quà tặng trong khoảng thời gian từ 0 đến 10 phút. Điều này giúp bạn dễ dàng sử dụng thẻ quà tặng của mình để mua sắm hoặc sử dụng dịch vụ tại các đối tác mà Giftcards.vn hỗ trợ."
                ]
            },
            {
                title: "Ví nào tương thích với Gift cards?",
                content: [
                    "Gift cards tương thích với tất cả các ví có mạng lưới BNB Smart Chain (BSC) và ONUS Chain. Điều này có nghĩa là nếu ví của bạn hoạt động trên mạng lưới này, bạn có thể sử dụng nó để thực hiện giao dịch trên Giftcards.vn.",
                    "Để tận dụng các giao dịch tức thì và miễn phí, đặc biệt nếu bạn là khách hàng thường xuyên, bạn có thể xem xét việc nạp tiền vào số dư của Gift cards. Lưu ý rằng số dư trong Gift cards không phải là một ví tiền điện tử, mà là một khoản tiền gửi trong cửa hàng. Mặc dù không phải là một ví, việc này cũng có thể giúp bạn tiết kiệm chi phí và thời gian chờ đợi cho các giao dịch thường xuyên, đồng thời tăng cường trải nghiệm mua sắm và thanh toán của bạn trên Giftcards.vn.",
                ]
            },
            {
                title:"Những loại tiền điện tử nào được Gift cards chấp nhận?",
                content: [
                    "Hiện tại, Gift cards chấp nhận các loại tiền điện tử sau để thanh toán:",
                    "- USDT (BEP-20): Đây là một loại stablecoin hoạt động trên mạng lưới Binance Smart Chain (BSC), mang giá trị ổn định với đồng USD.",
                    "- VNDC (Onus Wallet): Đây là một loại tiền điện tử hoạt động trên Onus Chain, cung cấp giá trị tương đương với đồng Việt Nam Đồng (VND).",
                    "Ngoài ra, Gift cards sẽ tích hợp ONUS Pay vào trang web của mình trong tương lai gần. ONUS Pay sẽ cho phép bạn thanh toán bằng nhiều loại tiền điện tử thay thế khác nhau, giúp tăng cường sự linh hoạt và lựa chọn trong việc thanh toán trên nền tảng của Gift cards."
                ]
            },
            {
                title:"Có giới hạn mua voucher trên Gift cards không?",
                content: [
                    "Hiện tại Giftcards không có giới hạn mua trong ngày cho các đơn hàng."
                ]
            },
            {
                title:"Khi nào đơn hàng của tôi được giao?",
                content: [
                    "Đơn hàng của bạn sẽ được giao ngay sau khi thanh toán được bảo đảm. Việc thanh toán sử dụng ONUS Wallet được chấp nhận ngay lập tức, giúp đơn hàng được xử lý và giao ngay sau khi thanh toán hoàn tất.",
                    "Các giao dịch USDT trên mạng lưới Bep-20, nếu có đủ phí giao dịch, cũng có thể được xử lý ngay lập tức, đảm bảo việc giao hàng nhanh chóng sau khi thanh toán hoàn tất.",
                    "Tuy nhiên, các loại giao dịch và tiền điện tử khác có thể yêu cầu thêm xác nhận từ mạng trước khi thanh toán được chấp nhận và đơn hàng của bạn được giao đi. Điều này có thể ảnh hưởng đến thời gian giao hàng, tùy thuộc vào thời gian xác nhận từ mạng của loại tiền điện tử bạn sử dụng.",

                ]
            },
            {
                title: "Gift cards có thêm hỗ trợ cho altcoin, tiền điện tử hoặc mã thông báo yêu thích của tôi không?",
                content: [
                    "Hiện tại, Gift cards chỉ hỗ trợ USDT và VNDC, ưu tiên hiện tại của chúng tôi là phát triển danh mục sản phẩm và dịch vụ trên ONUS pay. Tuy nhiên, chúng tôi hiện không có kế hoạch ngắn hạn để hỗ trợ thêm các loại tiền điện tử khác trong thời điểm này. Nếu chúng tôi thêm các loại tiền điện tử mới trong tương lai, chúng tôi sẽ ưu tiên theo quy mô cơ sở người dùng.",
                    `Nếu bạn muốn đề xuất một sản phẩm hoặc tiền điện tử khác để hỗ trợ, Gift cards rất hoan nghênh phản hồi của bạn. Bạn có thể chia sẻ ý kiến và đề xuất của mình bằng cách truy cập đường dẫn mà Gift cards cung cấp để gửi phản hồi của bạn. TẠI ĐÂY!`,
                    "Hãy nhớ rằng việc đưa ra phản hồi của bạn có thể giúp Gift cards hiểu rõ hơn về nhu cầu của cộng đồng người dùng và có thể đóng góp vào việc mở rộng danh mục sản phẩm và dịch vụ trong tương lai."
                ]
            },
            {
                title: "Chính sách hoàn trả của chúng tôi là gì?",
                content: [
                    "Nếu đơn hàng chưa được giao (thật không may, điều này đôi khi xảy ra do vấn đề của nhà điều hành), chúng tôi sẽ hoàn lại số tiền đã thanh toán ngay khi có thể, sau khi bạn gửi cho chúng tôi địa chỉ hoàn tiền. Nếu bạn chưa nhận được mã nạp tiền hoặc mã phiếu thưởng, vui lòng liên hệ với chúng tôi hoặc trả lời email biên nhận của bạn và chúng tôi sẽ xem xét. Vui lòng cung cấp tất cả thông tin đơn hàng hữu ích mà bạn có (ID đơn hàng, địa chỉ thanh toán, địa chỉ email hoặc số điện thoại bạn đang nạp tiền)",
                    "Lưu ý: nếu đơn hàng đã được giao thành công, chúng tôi không thể hủy đơn hàng đó. Vì vậy hãy chắc chắn rằng bạn đang gửi nó đến đúng số/email. Chúng tôi không thể hoàn trả mã chứng từ đã giao thành công; hãy đảm bảo bạn đang đặt hàng đúng sản phẩm!",
                    "Vui lòng xem lại chính sách hoàn tiền của chúng tôi .",
                    "Việc hoàn tiền phải được yêu cầu trong vòng 30 ngày kể từ ngày giao dịch.",
                    "Vì mục đích yêu cầu hoàn lại tiền hoặc bất kỳ thông tin nào khác, Khách hàng sẽ liên hệ với chúng tôi."
                ]
            },
            {
                title: "Những ưu điểm của GIFT CARDS",
                content: [
                    "+ Tận dụng tối đa điểm thưởng VNDC: Với GIFT CARDS, người dùng có thể dễ dàng đổi voucher của các thương hiệu nổi tiếng chỉ bằng cách sử dụng điểm thưởng VNDC của mình thông qua ví Onus...",
                    "+ Quy trình đổi voucher đơn giản: Với giao diện đơn giản và dễ hiểu, chỉ cần vài bước là người dùng có thể đổi voucher thành công.",
                    "GIFT CARDS là một nền tảng voucher tiên tiến, mang lại nhiều lợi ích cho người dùng. Với những ưu điểm vượt trội của mình, GIFT CARDS hứa hẹn sẽ trở thành một nền tảng voucher phổ biến tại Việt Nam và trên toàn thế giới."
                ]
            }
        ]
    },
    {
        type: FAQ_TYPE.ACCOUNT,
        isCollapse: false,
        faq: [
            {
                title:"Tôi không thể đăng nhập vào tài khoản của mình và không nhận được mã bạn đã gửi đến email của tôi.",
                content: [
                    "Đôi khi thư của chúng tôi được lọc vào thư mục SPAM, vui lòng kiểm tra ở đó trước. ",
                    "Nếu bạn vẫn gặp sự cố, vui lòng liên hệ với chúng tôi."
                ],
                image: "/images/giftcards/account_1.png",
            },
            {
                title: "Tôi có thể thay đổi email của mình không?",
                content: [
                    "Hiện tại với Thông tin cá nhân gồm số điện thoại, email nhận thông tin về Giftcard thì bạn hoàn toàn có thể đổi được, còn email liên quan đến kết nối ví khi đổi sang email khác sẽ có địa chỉ ví khác tương ứng với email mà bạn đã tạo với Giftcards."
                ],
                image: "/images/giftcards/account_2.png",
            }
        ]
    },
    {
        type: FAQ_TYPE.ORDER_AND_PAYMENT,
        isCollapse: !false,
        faq: [
            {
                title:"Giao dịch bằng mạng lưới BEP-20 có bị mất phí không?",
                content: [
                    "Giao dịch qua mạng lưới BEP-20 bạn sẽ phải chịu phí giao dịch. Tuỳ theo loại ví nào bạn đang sử dụng sẽ có các mức phí khác nhau, nhưng phí không quá nhiều."
                ]
            },
            {
                title: "Thanh toán qua ONUS Wallet có bị mất phí không?",
                content: [
                    "Thanh toán qua ONUS Wallet bạn sẽ không bị mất phí giao dịch."
                ]
            },
            {
                title:"Điều gì xảy ra nếu tôi gửi USDT đến sai địa chỉ?",
                content: [
                    "Nếu bạn gửi USDT đến sai địa chỉ hoặc gửi quá nhiều USDT cho một người lạ, khả năng cao là nó sẽ bị mất vĩnh viễn. Điều cực kỳ quan trọng là đảm bảo bạn sao chép toàn bộ chuỗi ký tự của địa chỉ USDT và kiểm tra kỹ xem địa chỉ đó và số tiền của bạn có chính xác hay không trước khi gửi thanh toán.",
                    "Đảm bảo luôn kiểm tra kỹ xem các ký tự ở đầu và cuối địa chỉ bạn đang sử dụng có chính xác giống với địa chỉ bạn định gửi.",
                    "Sử dụng mã QR để gửi và nhận hoặc sử dụng ONUS wallet cũng giảm thiểu đáng kể lỗi địa chỉ và số lượng."
                ]
            },
            {
                title: "Hiểu chính sách hoàn trả tiền điện tử của chúng tôi",
                content: [
                    "Đôi khi, mọi thứ không diễn ra như kế hoạch, dẫn đến việc phải hoàn lại tiền. Dưới đây là những điều bạn cần biết về chính sách hoàn tiền của chúng tôi khi thanh toán được thực hiện bằng tiền điện tử.",
                    "Hoàn tiền bằng USDT hoặc VNDC Số dư Gift cards.",
                    "Là một lựa chọn thay thế, bạn có thể chọn nhận tiền hoàn lại bằng số dư Gift cards, được biểu thị bằng USDT hoặc VNDC.",
                    "Ví dụ: nếu bạn mua thẻ quà tặng trị giá 250.000 VND bằng 250.000 VNDC, chúng tôi sẽ hoàn lại số dư Gift cards của bạn với 250.000 VNDC.",
                    "Có thêm thắc mắc hoặc cần làm rõ thêm? Vui lòng liên hệ với Nhóm hỗ trợ khách hàng của chúng tôi. Chúng tôi ở đây để giúp bạn."
                ]
            },
            {
                title: "Tôi không nhận được tiền hoàn lại của mình / tôi gặp lỗi khi yêu cầu hoàn lại tiền",
                content: [
                    "Khi yêu cầu hoàn lại tiền không thành công, có thể do một trong những lý do sau:",
                    "Giao dịch của bạn chưa được xác nhận, có nghĩa là chúng tôi chưa nhận được thanh toán của bạn. Khi giao dịch được xác nhận trên mạng, bạn sẽ có thể yêu cầu hoàn lại tiền.",
                    "Địa chỉ ví đã được nhập không chính xác. Vui lòng kiểm tra kỹ địa chỉ đã nhập và thử yêu cầu lại, đảm bảo rằng địa chỉ dành cho cùng một phương thức thanh toán mà bạn đã thanh toán.",
                    "Khoản tiền hoàn lại của bạn đã được xử lý đến địa chỉ hoặc tài khoản Gift cards của bạn.",
                    "Các lỗi kỹ thuật khác, vui lòng liên hệ với chúng tôi kèm theo ảnh chụp màn hình và ID hóa đơn của bạn."
                ]
            },
            {
                title: "Tôi chưa nhận được đơn hàng/ mã voucher của mình ngay lập tức",
                content: [
                    "Thông thường, nếu đơn đặt hàng bằng USDT với một khoản phí giao dịch đủ, nó sẽ được xử lý ngay lập tức. Nếu bạn đặt hàng bằng VNDC trên ONUS Wallet thì đơn hàng sẽ được xử lý ngay sau đó từ 1 giây- 15 phút."
                ]
            },
            {
                title: "Tôi đã thanh toán toàn bộ số tiền và tôi chưa nhận được thẻ quà tặng / nạp tiền điện thoại. Tôi nên làm gì?",
                content: [
                    `Trước tiên, chúng tôi muốn cho bạn biết rằng tiền của bạn vẫn an toàn. Bạn sẽ nhận được một chú giải cho biết "thanh toán đã được xác nhận".`,
                    "Nếu bạn chưa nhận được thẻ quà tặng / nạp tiền điện thoại, có thể do các lý do khác nhau:",
                    `   - Giao dịch vẫn chưa được xác nhận.`,
                    `   - Thanh toán không được nhận đúng hạn và hóa đơn đã hết hạn. Nếu thanh toán đã được gửi và giao dịch được xác nhận, vui lòng liên hệ với Bộ phận Dịch vụ Khách hàng với thông tin giao dịch / địa chỉ của bạn hoặc yêu cầu hoàn lại tiền trên trang thanh toán của bạn.`,
                    `   - Đơn đặt hàng đã được thanh toán thấp hơn giá trị đơn hàng.`,
                    `   - Lỗi kỹ thuật với đơn đặt hàng. Vui lòng liên hệ với bộ phận Dịch vụ Khách hàng.`
                ] 
            }
        ]
    },
    {
        type: FAQ_TYPE.DIGITAL_GIFT_VOUCHERS,
        isCollapse: false,
        faq: [
            {
                title: "Tôi không thể đổi mã thẻ quà tặng của mình",
                content: [
                    "Trong trường hợp bạn đang gặp bất kỳ vấn đề nào khi đổi mã thẻ quà tặng, vui lòng đảm bảo rằng địa chỉ IP hiện tại và tài khoản đổi quà của bạn khớp với khu vực mà sản phẩm hướng đến.",
                    "Nếu bạn vẫn gặp sự cố và để chúng tôi có thể giải quyết nhanh hơn cho bạn, vui lòng liên hệ với chúng tôi theo thông tin sau:",
                    "1. Ảnh chụp màn hình đầy đủ (hiển thị thanh URL) của các thông báo lỗi",
                    "2. Ảnh chụp màn hình cài đặt khu vực tài khoản của bạn trên ứng dụng đổi quà"
                ],
                image: "/images/giftcards/giftcard_1.png",
            },
            {
                title: "Mua làm quà tặng / Lên lịch gửi thẻ quà tặng",
                content: [
                    "Chúng tôi cho phép khách hàng mua thẻ quà tặng dưới dạng phiếu mua hàng có thể được gửi làm quà tặng cho người khác ngay lập tức hoặc vào một ngày đã định.",
                    "Tính năng này cho phép bạn hoàn toàn tùy chỉnh quà tặng của mình bằng cách bao gồm một thông điệp và chủ đề tùy chỉnh có thể được gửi qua email và in một cách dễ dàng."
                ],
                image: "/images/giftcards/giftcard_2.png",
            }
        ]
    },
    {
        type: FAQ_TYPE.CRYPTOCURRENCY_PAYMENT,
        isCollapse: !false,
        faq: [
            {
                title: "Tôi có thể đi du lịch và thanh toán bằng Gift cards không?",
                content: [
                    "Đặt vé máy bay, khách sạn khi đi du lịch có thể mất rất nhiều thời gian. Tuy nhiên, mọi chuyện không thể dễ dàng hơn với sự đa dạng của các loại dịch vụ mà chúng tôi cung cấp tại Gift cards. Chúng tôi cung cấp mọi thứ bạn cần để đặt chuyến bay, khách sạn và nhiều dịch vụ hơn thế nữa.",
                    "Chúng tôi cung cấp cho bạn các voucher chuyến bay, khách sạn, nhà hàng, thuê ô tô, Grab và thậm chí cả đổ xăng trên đường đi. Chưa kể tất cả các voucher cần thiết để bạn có thể ăn no khi đi du lịch vì ai lại thích đi du lịch khi bụng đói?"
                ]
            },
            {
                title: "Làm cách nào để book vé máy bay bằng Gift cards?",
                content: [
                    "Giờ đây, bạn có thể thanh toán cho chuyến bay tiếp theo của mình bằng USDT và VNDC bằng cách mua thẻ quà tặng từ Vietnam Airlines, Vietjet Air và Jetstar Pacific cùng với các hãng hàng không và trang web du lịch khác có liên kết với Gift cards."
                ]
            },
            {
                title: "Làm cách nào để đặt khách sạn bằng Gift cards?",
                content: [
                    "Thật không may, bạn không thể thanh toán trực tiếp cho khách sạn bằng USDT hay các loại tiền điện tử khác. Nhưng Gift cards có giải pháp! Mua thẻ quà tặng tại Traveloka, Agoda, Booking.com, Vntrip, iViVu hoặc nhiều trang web khách sạn khác bằng USDT, VNDC hoặc các loại tiền điện tử khác và chỉ cần đổi chúng trên các trang web tương ứng. Và bạn đã thanh toán chi phí lưu trú tại khách sạn của mình bằng tiền điện tử!"
                ]
            },
            {
                title: "Tôi có thể mua những thẻ Game nào bằng USDT và VNDC?",
                content: [
                    "Bạn có thể mua hầu hết mọi trò chơi bằng USDT, VNDC và tiền điện tử. Ngoài thẻ quà tặng từ các nhà phát hành game bạn cũng có thể mua tín dụng trò chơi cho Liên Quân, Liên Minh Huyền Thoại, FIFA Online 4 và các trò chơi khác từ nhà phát hành game Garena."
                ]
            },
            {
                title: "Tôi có thể mua các thiết bị điện tử như máy tính hoặc điện thoại di động bằng USDT và VNDC không?",
                content: [
                    "Dễ dàng mua máy tính hoặc iPhone yêu thích của bạn bằng USDT, VNDC bằng cách mua thẻ quà tặng từ Thế Giới Di Động, CellphoneS, FPT Shop, Phương Tùng hoặc các cửa hàng điện tử khác."
                ]
            },
            {
                title: 'Tôi có thể sử dụng Gift cards để thanh toán khi mua đồ ăn như Pizza và đi siêu thị mua sắm không?',
                content: [
                    "Nhận giao bánh pizza, hamburger hoặc thực phẩm khác bằng tiền điện tử từ Pizza Hut, Pizza Company, KFC, Jollibee, Lotteria, và các dịch vụ giao hàng khác hoặc đơn giản là mua sắm tại các siêu thị Vincom, Co.opmart, Mega Market, GO, Lotte Mart tại địa phương bằng tiền điện tử. Gift cards cung cấp nhiều thẻ quà tặng khác nhau từ các dịch vụ giao hàng và siêu thị mà bạn có thể mua bằng USDT, VNDC và các loại tiền điện tử khác."
                ]
            }
        ]
    },
]